/** 为了控制input输入框小数点的位数, 单独拉出来做处理 */
<template>
  <AmountInput ref="input" v-model="model">
    <span slot="append">{{ appendValue }}</span>
  </AmountInput>
</template>
<script>
import { Input as AmountInput } from '@didi/rich-ui'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  components: { AmountInput },
  props: {
    type: {},
    value: {},
    accuracy: {}, // 设置精度
    appendValue: {},
  },
  data() {
    return {
      innerValue: this.value,
    }
  },
  computed: {
    model: {
      get() {
        return this.innerValue
      },
      async set(newVal) {
        if (newVal > 0) {
          const accuracy = this.accuracy
          const regExpString = `^\\d+(?:\\.\\d{0,${accuracy}})?`
          const reg = new RegExp(regExpString)
          const num = newVal.toString().match(reg)
          if (num) {
            this.$refs.input.inputValue = num[0]
          }
        }
        this.$emit('input', newVal)
        this.$emit('change', newVal)
        // return newVal
      },
    },
  },
  watch: {
    value: {
      handler: function (newVal, oldVal) {
        if (newVal === undefined) {
          // 重置时无法对input进行undefined
          this.$refs.input.inputValue = undefined
        }
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
